let Advantages = {
    initEmployeesSlider: function(slider){
        slider.slick({
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            speed: 700,
            fade: true,
            arrows: true,
            dots: false,
            infinite: true,
            prevArrow : '<div class="slick-prev"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arr"></use></svg></span></div>',
            nextArrow : '<div class="slick-next"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arr"></use></svg></span></div>',
        })
        .on('beforeChange', function(event, slick){});
    }
}

$(document).ready(function ($) {
    let sliderEmployeesAdvantages = $('[data-slider-employees-advantages]');
    if(sliderEmployeesAdvantages.length){
        Advantages.initEmployeesSlider(sliderEmployeesAdvantages);
    }
    
});



// WEBPACK FOOTER //
// ./components/advantages.js